import { B2BPaymentMethod, CorePaymentMethod } from "@oysterhr/schema"

import {
  DestroyPaymentMethodsOptions,
  useDestroyPaymentMethod,
} from "./hooks/useDestroyPaymentMethod"

interface useDeletePaymentMethodProps {
  successCallback: () => void
  failureCallback: (errors: string[]) => void
  mutationOptions?: DestroyPaymentMethodsOptions
}

export const useDeletePaymentMethod = ({
  successCallback,
  failureCallback,
  mutationOptions,
}: useDeletePaymentMethodProps) => {
  const [destroyPaymentMethod, { loading: isDestroyingPaymentMethod }] = useDestroyPaymentMethod()

  const cleanup = () => {
    // For SEPA and BACS we check if we should show the mandate banner that
    // is dissmissable - we store the value in localStorage
    window.localStorage.setItem("paymentFlow-showMandateBanner", "true")
    // For ACH we check if we should show the creditor's ID banner that
    // is dissmissable - we store the value in localStorage
    window.localStorage.setItem("paymentFlow-showCreditorsIDBanner", "true")
  }

  const deletePaymentMethod = async (paymentMethod: CorePaymentMethod | B2BPaymentMethod) => {
    const { data } = await destroyPaymentMethod({
      ...mutationOptions,
      variables: { paymentMethodId: paymentMethod.id },
    })

    if (data?.destroyPaymentMethod.errors.length) {
      failureCallback(data.destroyPaymentMethod.errors)
    } else {
      cleanup()
      successCallback()
    }
  }

  return { deletePaymentMethod, loading: isDestroyingPaymentMethod }
}
